// define and export constants used for actions and reducers
export const CHANGE_SEARCH_FIELD ='CHANGE_SEARCH_FIELD';